import { client } from "client";
const useGeneralOptionsSettings = () => {
  const { useQuery } = client;
  return useQuery().generalOptionsSettings;
};

export default useGeneralOptionsSettings;
